export default __webpack_public_path__ + "static/media/Bullet 03.ae1d7b46.webp";